import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { debounce } from 'lodash';

@Component
export class CustomerForm extends ThemeComponent {
    @Ref({ required: false }) recoverToggle!: HTMLButtonElement[];
    @Ref({ required: false }) recover!: HTMLElement;
    @Ref({ required: false }) revealPasswordButton!: HTMLButtonElement;
    @Ref({ required: false }) passwordField!: HTMLInputElement;
    @Ref() submitButton!: HTMLInputElement;
    @Ref() form!: HTMLElement;

    protected url = location.href;

    init() {

        // Show form
        this.showForm();

        // Add recover password event listeners
        this.addRecoverPasswordEventListeners();

        // Add reveal password event listeners
        this.addRevealPasswordEventListener();

        // Enable/Disable submit buttonlistener
        this.addSubmitEnableEventListener();
    }

    showForm() {

        // Show login form
        if (!this.classList.contains('account-form--customer_login')) {
            this.form.classList.remove('account-form__form--hidden');
            return;
        }

        // Show recover password form
        if (this.recover.querySelector('.errors') === null && location.href.indexOf('#recover') > -1) {
            this.recover.classList.add('account-form__recover--active');
            this.form.classList.add('account-form__form--hidden');
            return;
        }
        this.recover.classList.remove('account-form__recover--active');
        this.form.classList.remove('account-form__form--hidden');
    }

    addRecoverPasswordEventListeners() {
        for (const button of this.recoverToggle) {
            button.addEventListener('click', () => this.handlePasswordRecover(button));
        }
    }

    addRevealPasswordEventListener() {
        if (this.revealPasswordButton && this.passwordField) {
            this.$listen(this.revealPasswordButton, 'click', () => {
                this.togglePasswordVisibility();
            });
        }
    }

    addSubmitEnableEventListener() {
        this.submitButton.disabled = true;
        const requiredFields = this.querySelectorAll('input:required') as NodeListOf<HTMLInputElement>;
        if (requiredFields) {
            this.$listen(this, 'keyup', debounce(() => {
                this.setSubmitState(requiredFields);
            }, 500));
        }
    }

    handlePasswordRecover(button: HTMLButtonElement|null) {
        this.recover.classList.toggle('account-form__recover--active');
        this.form.classList.toggle('account-form__form--hidden');

        if (button === null) { return; }
        const toggle = button?.dataset.toggle;
        this.updateLocationUrl(toggle);
    }

    updateLocationUrl(toggle: string|undefined) {
        if (toggle == 'show') {
            window.location.hash = 'recover';
            return;
        }

        history.replaceState(null, 'null', ' ');
    }

    togglePasswordVisibility() {
        const fieldType = this.passwordField.getAttribute('type');
        const icon = this.revealPasswordButton.querySelector('.icon');
        if (fieldType == 'password') {
            this.passwordField.setAttribute('type', 'text');
            if (icon) {
                icon.classList.add('visible');
            }
        } else {
            this.passwordField.setAttribute('type', 'password');
            if (icon) {
                icon.classList.remove('visible');
            }
        }
    }

    setSubmitState(requiredFields: NodeListOf<HTMLInputElement>) {
        this.submitButton.disabled = true;
        // eslint-disable-next-line max-len
        const invalidField = [...requiredFields].find((field) => !field.value || field.value == '');
        if (!invalidField) {
            this.submitButton.disabled = false;
        }
    }
}
